import { TFunction } from 'i18next'

import { InvoiceEditorVariant } from '../../../enums/invoiceEditorVariant'

export const getInvoiceEditorTitle = (invoiceEditorVariant: InvoiceEditorVariant, t: TFunction) => {
  const invoiceEditorVariantToTitle: Record<InvoiceEditorVariant, string> = {
    [InvoiceEditorVariant.CreditNoteFromInvoice]: t('external_invoices.editor.new_credit_note.title'),
    [InvoiceEditorVariant.InvoiceDraftDuplicate]: t('external_invoices.editor.new.title'),
    [InvoiceEditorVariant.InvoiceDraftEdit]: t('external_invoices.editor.edit_draft.title'),
    [InvoiceEditorVariant.DepositInvoiceDraftEdit]: t('external_invoices.editor.edit_draft_deposit_invoice.title'),
    [InvoiceEditorVariant.FinalInvoiceDraftEdit]: t('external_invoices.editor.edit_draft_final_invoice.title'),
    [InvoiceEditorVariant.InvoiceDuplicate]: t('external_invoices.editor.new.title'),
    [InvoiceEditorVariant.InvoiceNew]: t('external_invoices.editor.new.title'),
    [InvoiceEditorVariant.InvoiceNewFromQuote]: t('external_invoices.editor.new.title'),
    [InvoiceEditorVariant.DepositInvoiceNewFromQuote]: t('external_invoices.editor.new_deposit_invoice.title'),
    [InvoiceEditorVariant.FinalInvoiceNewFromQuote]: t('external_invoices.editor.new_final_invoice.title'),
    [InvoiceEditorVariant.QuoteDraftDuplicate]: t('external_invoices.editor.new_quote.title'),
    [InvoiceEditorVariant.QuoteDraftEdit]: t('external_invoices.editor.edit_draft_quote.title'),
    [InvoiceEditorVariant.QuoteDuplicate]: t('external_invoices.editor.new_quote.title'),
    [InvoiceEditorVariant.QuoteEdit]: t('external_invoices.editor.edit_quote.title'),
    [InvoiceEditorVariant.QuoteNew]: t('external_invoices.editor.new_quote.title'),
    [InvoiceEditorVariant.RecurringInvoiceDraftEdit]: t('external_invoices.editor.edit_draft_recurring_invoice.title'),
    [InvoiceEditorVariant.RecurringInvoiceDuplicate]: t('external_invoices.editor.new_recurring_invoice.title'),
    [InvoiceEditorVariant.RecurringInvoiceEdit]: t('external_invoices.editor.edit_recurring_invoice.title'),
    [InvoiceEditorVariant.RecurringInvoiceNew]: t('external_invoices.editor.new_recurring_invoice.title'),
  }

  return invoiceEditorVariantToTitle[invoiceEditorVariant]
}
